/* eslint-disable no-undef */
import * as Sentry from "@sentry/react";
import { REACT_APP_SENTRY_ENV } from "./config";

const isLocal = REACT_APP_SENTRY_ENV === "local";

if (!isLocal) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,

    sendDefaultPii: true,
    environment: process.env.REACT_APP_SENTRY_ENV,
    beforeSend(event) {
      event.tags = {
        ...event.tags,
        service_name: "Customer Portal",
      };
      return event;
    },
    integrations: [Sentry.browserTracingIntegration()],
  });
}
